import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ImageFileIcon = (props: IconProps) => (
  <Icon w="62px" h="68px" viewBox="0 0 62 68" {...props}>
    <path d="M57.209.166H5.789C2.931.166.074 3.98.074 7.796v53.408c0 4.197 2.57 7.63 5.713 7.63h51.42c2.857 0 5.714-3.815 5.714-7.63V7.796c0-3.815-2.857-7.63-5.713-7.63ZM11.502 53.575 21.5 36.407l7.142 11.483 9.998-17.205 12.855 22.89H11.502Z" />
  </Icon>
);

export default memo(ImageFileIcon);
